import AuthSignUpFanTabComponent from "./AuthSignUpFanTabComponent";

export default AuthSignUpFanTabComponent;
